import { useState } from "react";
import { ThumbsUp, ThumbsDown, Flag } from "lucide-react";
import { toast } from "sonner";
import { trackEvent } from "@/hooks/useArticleAnalytics";

/* Article feedback (§36): quiet controls, never a major CTA block. */
export const FeedbackRow = ({ slug }: { slug: string }) => {
  const KEY = `nl-fb-${slug}`;
  const [voted, setVoted] = useState<string | null>(() => localStorage.getItem(KEY));

  const vote = (helpful: boolean) => {
    if (voted) return;
    const v = helpful ? "up" : "down";
    localStorage.setItem(KEY, v);
    setVoted(v);
    trackEvent("article_feedback", { slug, helpful });
  };
  const report = () => {
    trackEvent("article_report_issue", { slug });
    toast.success("Thanks — our editors have been notified.");
  };

  return (
    <div data-testid="article-feedback-row"
      className="mt-8 flex flex-wrap items-center justify-between gap-3 border-t border-white/[0.07] pt-4">
      <div className="flex items-center gap-3">
        {voted ? (
          <p className="text-[12.5px] text-gray-500" data-testid="feedback-thanks">Thanks for the feedback.</p>
        ) : (
          <>
            <p className="text-[12.5px] text-gray-500">Was this article helpful?</p>
            <button type="button" onClick={() => vote(true)} data-testid="feedback-helpful-yes"
              aria-label="Yes, this article was helpful"
              className="rounded-lg border border-white/[0.1] p-1.5 text-gray-500 hover:text-[#34D399] hover:border-[#34D399]/40 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00E5FF]/60">
              <ThumbsUp className="h-3.5 w-3.5" />
            </button>
            <button type="button" onClick={() => vote(false)} data-testid="feedback-helpful-no"
              aria-label="No, this article was not helpful"
              className="rounded-lg border border-white/[0.1] p-1.5 text-gray-500 hover:text-[#EF4444] hover:border-[#EF4444]/40 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00E5FF]/60">
              <ThumbsDown className="h-3.5 w-3.5" />
            </button>
          </>
        )}
      </div>
      <button type="button" onClick={report} data-testid="feedback-report-issue"
        className="inline-flex items-center gap-1.5 font-mono text-[10.5px] text-gray-600 hover:text-gray-300 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00E5FF]/60 rounded">
        Report an issue <Flag className="h-3 w-3" aria-hidden />
      </button>
    </div>
  );
};
